Vue.component('announcementDrawer', {
  template: templates.announcementDrawer,
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: {
        isOpen: false,
        announcement: {
          id: null,
          title: null,
          description: null,
          startDate: null,
          endDate : null,
          description: null,
          images: {},
          video: null,
          cooldown: null,
          titleSize: 2.5,
          descSize: 1.2,
          verticalPos: 'bottom',
          horizontalPos: 'left',
        },
        timer: null,
        slideIndex: 1,
        slides: []
      }
    }
  },
  created() {
    const c = this;

  },
  computed: {
    slides() {
      const images = this.model.announcement.images;
      
      // Check if images exists and is an object
      if (images && Object.keys(images).length > 0) {
          return Object.values(images).map(img => 
            `${this.getAnnouncementUrl()}${img}`
          );
      } else {
        // Return default slides with type property
        return [
          {
            type: 'image',
            src: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1200'
          },
          {
            type: 'image',
            src: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=1200'
          },
          {
            type: 'image',
            src: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1200'
          }
        ];
      }
    },
    overlayStyle() {
      const baseStyle = {
        textAlign: this.model.announcement.horizontalPos,
        transition: 'all 0.3s ease'
      };

      if (this.model.announcement.verticalPos === 'top') {
        return {
          ...baseStyle,
          top: '0',
          bottom: 'auto',
          padding: '30px 30px 20px',
          background: 'linear-gradient(rgba(0, 0, 0, 0.7), transparent)',
          transform: 'none'
        };
      } else if (this.model.announcement.verticalPos === 'center') {
        return {
          ...baseStyle,
          top: '50%',
          bottom: 'auto',
          padding: '40px 30px',
          background: 'rgba(0, 0, 0, 0.7)',
          transform: 'translateY(-50%)'
        };
      } else {
        return {
          ...baseStyle,
          top: 'auto',
          bottom: '0',
          padding: '40px 30px 30px',
          background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
          transform: 'none'
        };
      }
    },
    titleStyle() {
      return {
        fontSize: `${this.model.announcement.titleSize}rem`,
        textAlign: this.model.announcement.horizontalPos
      };
    },
    descriptionStyle() {
      const style = {
        fontSize: `${this.model.announcement.descSize}rem`
      };

      if (this.model.announcement.horizontalPos === 'center') {
        style.maxWidth = '100%';
        style.margin = '0 auto';
      } else if (this.model.announcement.horizontalPos === 'left') {
        style.maxWidth = '80%';
        style.margin = '0';
      } else {
        style.maxWidth = '80%';
        style.marginLeft = 'auto';
      }

      return style;
    }
  },
  mounted() {
    const c = this;

    c.get();
    c.connect();
    c.startTimers();

    c.$root.$on('open-announcement-modal', () =>{
      c.get();
    })

    // c.$root.$on('open-events-modal', () =>{
    //   c.model.isOpen = false
    // })

  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());
  
      c.ws.onmessage = (event) => {
  
          const messageData = event.data;
  
          try {
  
            const parsedData = JSON.parse(messageData);
        
            if(parsedData.message === 'announcement'){
              c.closeDrawer()
              setTimeout(function(){
                c.get();
              },1000)
            
            }

          } catch (error) {
          console.error('Error parsing message data:', error);
          }
      
      };
  
      c.ws.onopen = () => {
          console.log('WebSocket connection established');
      };
  
      c.ws.onclose = () => {
          console.log('WebSocket connection closed');
      };
    },
   async get() {
      const c = this;
      try {
        const response = await announcementService.getActiveAnnouncement();
        console.log('Raw response:', response.data);

        if (!response.data || response.data.length === 0) {
          console.warn('No active announcements found.');
          // Optionally: c.model.announcement = null; or show a default message
          return;
        }

        const announcementData = response.data[0];
        c.model.announcement = {
          img: `${root}/images/announcement/${announcementData.id}.png`,
          name: announcementData.name,
          description: announcementData.description,
          startDate: announcementData.startDate,
          endDate: announcementData.endDate,
          cooldown: announcementData.cooldown,
          titleSize: announcementData.titleSize,
          descSize: announcementData.descSize,
          verticalPos: announcementData.verticalPos,
          horizontalPos: announcementData.horizontalPos,
        };

        console.log('Processed images:', announcementData.images);

        // Process slides: Filter out null/undefined/empty values first, then map
        c.model.slides = announcementData.images
          ? Object.values(announcementData.images)
              .filter(file => file && typeof file === 'string' && file.trim() !== '') // Ignore null, undefined, or empty strings
              .map(file => {
                const extension = file.split('.').pop()?.toLowerCase() || ''; // Safer extension extraction
                const type = extension === 'mp4' ? 'video' : 'image'; // Add more extensions if needed (e.g., 'webm' for video)
                return {
                  type,
                  src: `${root}/images/announcement/${announcementData.id}/${file}`
                };
              })
          : []; // Empty array if no images

        // Log the filtered slides for debugging
        console.log('Filtered slides:', c.model.slides);

        // Date checks: Ensure it's active (start <= now <= end)
        const now = new Date();
        const startDate = new Date(announcementData.startDate);
        const endDate = new Date(announcementData.endDate);

        if (startDate <= now && endDate > now) {
          // Ensure slideIndex is initialized if needed (assuming it's 0 by default)
          if (typeof c.model.slideIndex === 'undefined') {
            c.model.slideIndex = 0;
          }
          
          c.showSlides(c.model.slideIndex);
          
          const header = document.querySelector('.header');
          if (header) {
            header.classList.toggle('z-index-zero');
          } else {
            console.warn('Header element not found.');
          }

          // Toggle isOpen (ensure it's initialized to false if undefined)
          c.model.isOpen = typeof c.model.isOpen === 'undefined' ? true : !c.model.isOpen;
        } else {
          console.log('Announcement not active (expired or not started).');
          // Optionally: Close drawer or hide UI
          // c.closeDrawer();
        }

        console.log('Updated model:', c.model); // Now logs after updates
      } catch (error) {
        console.error('Error fetching announcement:', error);
        // Better error handling: Show a toast, reset model, etc.
        // c.model.announcement = null;
        // Optionally: c.closeDrawer();
      }
    },
    startTimers() {
      const c = this;

      setInterval(() => {
        let announcement = c.model.announcement
        if (announcement.cooldown > 0) {
          // let seconds = Math.round(inventory.cooldown * 60);
          announcement.cooldown -= 1; 

          c.formatTime(announcement.cooldown)
        }
        else{
          c.isOpen = false;
        }
        
 
      }, 1000);
      
    },
    formatTime(time) {
      const c = this;
      // Days, hours, minutes, and seconds
      var days = ~~(time / 86400); // Calculate days
      var hrs = ~~((time % 86400) / 3600); // Calculate hours
      var mins = ~~((time % 3600) / 60); // Calculate minutes
      var secs = ~~time % 60; // Calculate seconds
  
      var ret = "";
      if (days > 0) {
          ret += days + " days "; 
      }
      if (hrs > 0) {
          ret += hrs + "h:" + (mins < 10 ? "0" : "");
      }
      ret += mins + "m:" + (secs < 10 ? "0" : "");
      ret += secs;
  
      c.model.timer = ret;
    },
    closeDrawer() {
        const c = this;
   
        // $('.announcement-drawer').addClass('open-drawer');
        $('.announcement-overlay').removeClass('is-above').removeClass('is-visible');
        setTimeout(function(){
          c.isOpen = false;

          $('.header').removeClass('z-index-zero');
        },500);

        announcementService.announcementClosed().then(function(response){
          
        })
        .catch(function(error){
          console.log(error)
        })
        
    },
   
    toggleDrawer() {
        const c = this;

        c.isOpen = true;
    },
    plusSlides(n) {
      const c = this;
      c.showSlides(c.model.slideIndex + n);
    },
 
    currentSlide(n) {
      const c = this;
      c.showSlides(n);
    },
    showSlides(n) {
      const c = this;
      const totalSlides = c.model.slides.length;
      if(totalSlides === 0) return;
      if(n > totalSlides) {
        c.model.slideIndex = 1;
      } else if(n < 1) {
        c.model.slideIndex = totalSlides;
      } else {
        c.model.slideIndex = n;
      }

      c.startAutoSlide();
    },
    startAutoSlide() {
      const c = this;
      if (c.autoSlideInterval) clearInterval(c.autoSlideInterval);
      c.autoSlideInterval = setInterval(() => {
        c.showSlides(c.model.slideIndex + 1);
      }, 5000);
    },
  }
});